module.exports = __webpack_public_path__ + "static/media/angle-bg.fe1bfdab.webp";